<template>
    <div id="catalogWrapper">
        <h2>{{title}}</h2>
        <div id="tabulator" class="unselectable" >        
        </div>
    </div>
</template>


<script>
//var Tabulator = require("tabulator-tables"); //import Tabulator library
//var newData = [];
//var Tabulator = require("tabulator-tables"); // import Tabulator from "tabulator-tables";
//[{ id: 1, title: "Oli Bob"}, { id: 2, title: "Mary May"}, { id: 3, title: "Christine Lobowski"}, ],
//data: this.$store.state.tableData, //link data to table
//this.tabulator = new Tabulator(this.$refs.table, { data: this.tableData, //link data to table
//width:"100px",
//this.$store.tableData
//    methods:{
//        replaceData(newData){
//            this.tabulator.replaceData(newData);
//        }
//    },
//this.tableData = this.$store.state.tableData;

//    watch: { //update table if data changes
//        tableData: { handler: function (newData) {
//             this.tabulator.replaceData(newData); }, deep: true, } 
//    },

let catalog = null;
export default {
    name:'tabulator',
    props: {
        title: ''
    },    
    data: function () {
           return {
               tabulator: null,
               //tableData: []
            }
     }, 

    watch: { //update table if data changes
        getTableData: { handler: function (newData) { this.tabulator.replaceData(newData); } , deep: false }
    },

    computed:{
        getTableData(){            
        //    if (this.tabulator) {
//                this.tabulator.replaceData(this.$store.state.tableData);
//                }
            return this.$store.state.tableData;
        }
    },
    
    methods:{
        cellDblClick (e,cell){
            console.dir(cell);
            let row = cell.getRow();
            let rowData = row.getData();
            let id = rowData.id;
            let qty = 1;          
            //let editorData = this.$store.state.editorData;
            //console.dir(editorData);
            //var isRecordExists = function(id){  return editorData.filter(function(obj) { return obj.id === id; }); }
            let editor =  this.$store.state.editor;
            var addOrUpdateRecord = function pushToArray(arr, obj) {
                  const index = arr.findIndex((e) => e.id === obj.id);
                  if (index === -1) {
                  arr.push(obj);  console.log(obj.id + ' Not found. adding record');
                  rowData.qty = 1;
                  editor.addRow(rowData, false);
                } else {
                  //obj.qty = parseFloat(obj.qty) + 1;
                  arr[index].qty = parseFloat(arr[index].qty) + 1;
                  arr[index] = obj;  console.log(obj.id + ' Found. Updating record');
//                  console.dir(JSON.stringify( arr[index]) ) ;
                  var newPos = 1;
                  let ret = editor.updateOrAddData([ { id:arr[index].id, qty:arr[index].qty } ])
                  .then(function(rows){                      
                         setTimeout(function(){    
                            newPos =  rows[0].getPosition;
                            console.dir(rows[0].getPosition());
                            console.dir(ret); }, 100
                            );
                    });
                   if (newPos > 0) { //editor.scrollToRow(newPos); 
                   }
                }
            }            
            

            //.then(result => {return new Thenable(result); // (*) })
            //table.updateOrAddData([{id:1, name:"bob"}, {id:3, name:"steve"}]);
            addOrUpdateRecord(this.$store.state.editorData, rowData); 
            
            //addOrUpdateRecord(this.$store.state.editorData, rowData);          
            //this.$store.state.editor.addData([{id:1, title:"bob"}, {id:2, title:"Jenny"}], true);
        }
    },

    mounted() { //instantiate Tabulator when element is mounted     
      catalog = this;
      const aData = this.$store.state.tableData;
      this.tabulator = new Tabulator('#tabulator', {
        movableRows: true,        
        //movableRowsReceiver: "replace",
        movableRowsConnectedTables: "#editor",
        //data: this.tableData, //link data to table
        data: aData, //link data to table
        placeholder:"Данные не загружены",
        groupToggleElement:"header",
        columnAlign:"center", 
        layout:"fitData",
        height: "500px",      
        columns: [
          { title: "id", field: "id", width: 10, align: "right", visible:false, headerSort:false },
          { title: "Шифр", field:"cipher", width:80, align:"center", headerSort:false },          
          { title:"Наименование", field:"title",  width:500, align:"left", headerSort:false, formatter:"textarea"},
          { title: "Кол-во", field: "qty", width:80, align: "center", visible:false, headerSort:false},
          ],

        cellDblClick :this.cellDblClick 
        //cellClick:function(e,cell){  }
        },               
     );
      this.$store.state.catalog = this.tabulator;

      this.$store.dispatch('loadCatalog','/data/jrecords.json');
    }
 }
</script>





<style>
   *.unselectable {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently */
    }

.tabulator-moving{
    width: fit-content !important;
    font-size: .87rem !important;
    border: 1px solid #ccc !important; 
    border-radius: 2px;
    box-shadow: 0 8px 8px rgba(10,10,10,.1);
}

.tabulator-moving {max-width: 500px !important; text-overflow: ellipsis !important}
.tabulator-moving [tabulator-field="id"]{display:none !important}
.tabulator-moving [tabulator-field="cipher"]{display:none !important}
.tabulator-moving [tabulator-field="title"]{
    width: fit-content !important;
    max-width: 500px;
    white-space: pre-wrap !important;
    height: auto !important;
    text-overflow: ellipsis !important;
    border-right: 0px solid #ccc !important;
    background: white;
    padding: .5em 1rem;
}
.tabulator-moving [tabulator-field="qty"]{display:none !important}
</style>